export function getActive (list) {
  if (!list) {
    return []
  }
  return list.filter(next => next && next.info && next.info.status === 'ACTIVE')
}
